import { EventEmitter, Injectable, Output } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { plainToClass } from 'class-transformer';

import { ObservableRequestService } from 'app/services/observable-request.service';
import { ConstantsService } from 'app/services/constants-service';

import { SanctionLog } from 'app/shared/models/SanctionLog.model';


@Injectable()
export class ReportsService {


    constructor(private requestService: ObservableRequestService) { }

    getSanctionMatchingLogsList(): Observable<any> {
        return this.requestService.getRequest(ConstantsService.SANCTION_LOGS_ENDPOINT)
            .map(response => {
                return plainToClass(SanctionLog, response.arrResult as Object);
            });
    }

    getClientForISIReport(functionName, year): Observable<any> {
        return this.requestService.getRequest(ConstantsService.MAIN_ISI_REPORT + '?functionName=' + functionName + '&year=' + year);
    }

    getPersonForISIReport(functionName, year): Observable<any> {
        return this.requestService.getRequest(ConstantsService.MAIN_ISI_REPORT_PERSON + '?functionName=' + functionName + '&year=' + year);
    }

    getCountryWisePersonForISIReport(functionName, year): Observable<any> {
        return this.requestService.getRequest(ConstantsService.MAIN_ISI_REPORT_COUNTRY_WISE_PERSON
            + '?functionName=' + functionName + '&year=' + year);
    }

    getCountryWiseEntityForISIReport(functionName, year): Observable<any> {
        return this.requestService.getRequest(ConstantsService.MAIN_ISI_REPORT_COUNTRY_WISE_ENTITY
            + '?functionName=' + functionName + '&year=' + year);
    }

    getStructureWiseEntityForISIReport(functionName, year): Observable<any> {
        return this.requestService.getRequest(ConstantsService.MAIN_ISI_REPORT_STRUCTURE_WISE_ENTITY
            + '?functionName=' + functionName + '&year=' + year);
    }

    getClientForISISubReport(functionName, orgId, year): Observable<any> {
        return this.requestService.getRequest(ConstantsService.SUB_ISI_REPORT
            + '?functionName=' + functionName + '&orgId=' + orgId + '&year=' + year);
    }

    getPersonForISISubReport(functionName, orgId, year): Observable<any> {
        return this.requestService.getRequest(ConstantsService.SUB_ISI_REPORT_PERSON
            + '?functionName=' + functionName + '&orgId=' + orgId + '&year=' + year);
    }

    getCountryWisePersonForISISubReport(functionName, orgId, year): Observable<any> {
        return this.requestService.getRequest(ConstantsService.SUB_ISI_REPORT_COUNTRY_WISE_PERSON
            + '?functionName=' + functionName + '&orgId=' + orgId + '&year=' + year);
    }

    getCountryWiseEntityForISISubReport(functionName, orgId, year): Observable<any> {
        return this.requestService.getRequest(ConstantsService.SUB_ISI_REPORT_COUNTRY_WISE_ENTITY
            + '?functionName=' + functionName + (orgId ? '&orgId=' + orgId : '') + '&year=' + year);
    }

    getStructureEntityForISISubReport(functionName, orgId, year): Observable<any> {
        return this.requestService.getRequest(ConstantsService.SUB_ISI_REPORT_STRUCTURE_WISE_ENTITY
            + '?functionName=' + functionName + '&orgId=' + orgId + '&year=' + year);
    }

    getStructureWiseEntityForISISubReport(functionName, orgId, year): Observable<any> {
      return this.requestService.getRequest(ConstantsService.SUB_ISI_REPORT_STRUCTURE_WISE_ENTITY
        + '?functionName=' + functionName + '&orgId=' + orgId + '&year=' + year);
    }
}



// WEBPACK FOOTER //
// ./src/app/reports/reports.service.ts